import { render, staticRenderFns } from "./ViCountryCodePicker.vue?vue&type=template&id=5c0db8aa&"
import script from "./ViCountryCodePicker.vue?vue&type=script&lang=js&"
export * from "./ViCountryCodePicker.vue?vue&type=script&lang=js&"
import style0 from "./ViCountryCodePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports